document.addEventListener("DOMContentLoaded", () => {

    let selectedProducts = [];

    const giftItems = document.getElementById("giftItems");
    const giftTotal = document.getElementById("giftTotal");
    const giftCart = document.getElementById("giftCart");

    // Render Gift Summary
    function renderGift() {

        giftItems.innerHTML = "";

        let total = 0;

        selectedProducts.forEach(product => {

            total += product.price * product.quantity;

            giftItems.innerHTML += `
                <div class="gift-row">

                    <div class="gift-info">

                        <div class="gift-title">
                            ${product.title}
                        </div>

                        <div class="gift-price">
                            Rs. ${((product.price * product.quantity) / 100).toFixed(2)}
                        </div>

                    </div>

                    <div class="gift-actions">

                        <button class="qty-minus" data-id="${product.id}">
                            −
                        </button>

                        <span class="qty">
                            ${product.quantity}
                        </span>

                        <button class="qty-plus" data-id="${product.id}">
                            +
                        </button>

                        <button class="remove-item" data-id="${product.id}">
                            ✕
                        </button>

                    </div>

                </div>
            `;

        });

        giftTotal.innerHTML =
            "Rs. " +
            (total / 100).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            // Update mobile summary
const mobileTotal = document.getElementById("giftMobileTotal");
const mobileCount = document.getElementById("giftMobileCount");

if (mobileTotal) {
    mobileTotal.textContent = giftTotal.textContent;
}

if (mobileCount) {
    const totalQty = selectedProducts.reduce((sum, item) => sum + item.quantity, 0);
    mobileCount.textContent = `${totalQty} ${totalQty === 1 ? "Item" : "Items"}`;
}

        bindRemoveButtons();
        bindQuantityButtons();

    }

    // Add Product
    document.querySelectorAll(".gift-add").forEach(button => {

        button.addEventListener("click", function () {

            const id = this.dataset.id;

            const existing = selectedProducts.find(p => p.id == id);

            if (existing) {

                existing.quantity++;

            } else {

                selectedProducts.push({

                    id: id,
                    title: this.dataset.title,
                    price: Number(this.dataset.price),
                    quantity: 1

                });

                this.classList.add("active");
                this.innerHTML = "✓ Added";

            }

            renderGift();

        });

    });

    // Remove Product
    function bindRemoveButtons() {

        document.querySelectorAll(".remove-item").forEach(btn => {

            btn.onclick = function () {

                const id = this.dataset.id;

                selectedProducts = selectedProducts.filter(item => item.id != id);

                const addBtn = document.querySelector(`.gift-add[data-id="${id}"]`);

                if (addBtn) {

                    addBtn.classList.remove("active");
                    addBtn.innerHTML = "Add to Gift";

                }

                renderGift();

            }

        });

    }

    // Quantity
    function bindQuantityButtons() {

        document.querySelectorAll(".qty-plus").forEach(btn => {

            btn.onclick = function () {

                const product = selectedProducts.find(p => p.id == this.dataset.id);

                if (product) {

                    product.quantity++;

                    renderGift();

                }

            }

        });

        document.querySelectorAll(".qty-minus").forEach(btn => {

            btn.onclick = function () {

                const product = selectedProducts.find(p => p.id == this.dataset.id);

                if (!product) return;

                if (product.quantity > 1) {

                    product.quantity--;

                } else {

                    selectedProducts = selectedProducts.filter(
                        p => p.id != product.id
                    );

                    const addBtn = document.querySelector(`.gift-add[data-id="${product.id}"]`);

                    if (addBtn) {

                        addBtn.classList.remove("active");
                        addBtn.innerHTML = "Add to Gift";

                    }

                }

                renderGift();

            }

        });

    }

    // Add Everything to Shopify Cart
    giftCart.addEventListener("click", async () => {

        if (selectedProducts.length === 0) {

            alert("Please select at least one product.");

            return;

        }

        const items = selectedProducts.map(product => ({

            id: product.id,

            quantity: product.quantity

        }));

        giftCart.disabled = true;
        giftCart.innerHTML = "Adding...";

        try {

            const response = await fetch("/cart/add.js", {

                method: "POST",

                headers: {

                    "Content-Type": "application/json"

                },

                body: JSON.stringify({

                    items: items

                })

            });

            if (response.ok) {

                window.location.href = "/cart";

            } else {

                const error = await response.json();

                console.error(error);

                alert(error.description || "Unable to add products.");

            }

        } catch (error) {

            console.error(error);

            alert("Something went wrong.");

        }

        giftCart.disabled = false;
        giftCart.innerHTML = "Add All To Cart";

    });

});


const giftToggle = document.getElementById("giftToggle");
const giftSummary = document.querySelector(".gift-summary");

if (giftToggle && giftSummary) {

    giftToggle.addEventListener("click", function () {

        giftSummary.classList.toggle("open");

        this.innerHTML = giftSummary.classList.contains("open")
            ? "Hide Gift ▼"
            : "View Gift ▲";

    });

}

// ---- Sticky fallback for desktop ----
// In case CSS position:sticky is blocked by an ancestor (overflow or transform
// set somewhere in the theme), this pins the summary using fixed positioning
// based on actual scroll position instead.
(function () {

    const summary = document.querySelector(".gift-summary");
    const wrapper = document.querySelector(".gift-mobile-summary");
    const products = document.querySelector(".gift-products");

    if (!summary || !wrapper || !products) return;

    const TOP_OFFSET = 120;

    let wrapperTop = 0;
    let wrapperLeft = 0;
    let wrapperWidth = 0;
    let productsBottom = 0;

    function isDesktop() {
        return window.innerWidth > 900;
    }

    function reset() {
        summary.style.position = "";
        summary.style.top = "";
        summary.style.left = "";
        summary.style.width = "";
        summary.style.bottom = "";
    }

    function measure() {

        if (!isDesktop()) return;

        reset(); // make sure we measure the natural (non-fixed) position

        const wrapperRect = wrapper.getBoundingClientRect();
        const productsRect = products.getBoundingClientRect();

        wrapperTop = wrapperRect.top + window.scrollY;
        wrapperLeft = wrapperRect.left;
        wrapperWidth = wrapperRect.width;
        productsBottom = productsRect.bottom + window.scrollY;

        update();

    }

    function update() {

        if (!isDesktop()) {
            reset();
            return;
        }

        const summaryHeight = summary.offsetHeight;
        const maxScrollY = productsBottom - summaryHeight - TOP_OFFSET;
        const scrollY = window.scrollY;

        if (scrollY + TOP_OFFSET < wrapperTop) {

            reset();

        } else if (scrollY > maxScrollY) {

            summary.style.position = "absolute";
            summary.style.top = (productsBottom - summaryHeight - wrapperTop) + "px";
            summary.style.left = "0";
            summary.style.width = wrapperWidth + "px";
            summary.style.bottom = "";

        } else {

            summary.style.position = "fixed";
            summary.style.top = TOP_OFFSET + "px";
            summary.style.left = wrapperLeft + "px";
            summary.style.width = wrapperWidth + "px";
            summary.style.bottom = "";

        }

    }

    window.addEventListener("scroll", update);
    window.addEventListener("resize", measure);
    window.addEventListener("load", measure);

    measure();

})();


window.addEventListener("load", function () {
    const interval = setInterval(() => {
        const btn = document.getElementById("df-btn-cont");
        if (btn) {
            btn.style.display = "none";
            clearInterval(interval);
        }
    }, 300);
});